export default "__VITE_ASSET__B1P_x4hu__"